export interface Model180 {
  modelo: string;
  ejercicio: number;
  sujetoNIF: string;
  sujetoRazonSocial: string;
  contactoTelefono: string;
  contactoNombre: string;
  numeroIdentificativo: string;
  complementaria: boolean;
  sustitutiva: boolean;
  justificante: string;
  numeroPerceptores: number;
  totalBase: number;
  totalRetenciones: number;
  avisos: string[];
}

export interface Model180Validation {
  key: string | null;
  type: string;
  message: string;
}

export interface Model180Recipient {
  clave: string | null;
  uid: string | null;
  origen: string;
  sobrescribeClave: string | null;
  nifPerceptor: string;
  nifRepresentante: string;
  nombre: string;
  provinciaPerceptor: string;
  modalidad: string;
  reintegro: boolean;
  base: number;
  porcentaje: number;
  retencion: number;
  ejercicioDevengo: number;
  situacionInmueble: string;
  referenciaCatastral: string;
  tipoVia: string;
  nombreVia: string;
  tipoNumeracion: string;
  numeroCasa: string;
  calificador: string;
  bloque: string;
  portal: string;
  escalera: string;
  planta: string;
  puerta: string;
  complemento: string;
  localidad: string;
  municipio: string;
  codigoMunicipio: string;
  provinciaInmueble: string;
  codigoPostal: string;
}

export interface Model180RecipientList {
  items: Model180Recipient[];
  total: number;
  page: number;
  pageSize: number;
  totalBase: number;
  totalRetenciones: number;
}

export interface Model180ListQuery {
  year: number;
  page: number;
  pageSize: number;
  search: string;
  sortBy: string;
  sortDirection: string;
}

export interface Model180FieldOriginQuery {
  campo: string;
  taxYear: number;
  valorEnElFormulario: number | null;
}

export const ORIGEN_CONTABILIDAD = 'CONTABILIDAD';
export const ORIGEN_MANUAL = 'MANUAL';

export function nuevoModelo180(): Model180 {
  return {
    modelo: '180',
    ejercicio: new Date().getFullYear() - 1,
    sujetoNIF: '',
    sujetoRazonSocial: '',
    contactoTelefono: '',
    contactoNombre: '',
    numeroIdentificativo: '',
    complementaria: false,
    sustitutiva: false,
    justificante: '',
    numeroPerceptores: 0,
    totalBase: 0,
    totalRetenciones: 0,
    avisos: []
  };
}

export function normalizarModelo180(origen: Partial<Model180>): Model180 {
  const modelo: Model180 = { ...nuevoModelo180(), ...(origen || {}) } as Model180;

  modelo.modelo = '180';
  modelo.sujetoNIF = modelo.sujetoNIF || '';
  modelo.sujetoRazonSocial = modelo.sujetoRazonSocial || '';
  modelo.contactoTelefono = modelo.contactoTelefono || '';
  modelo.contactoNombre = modelo.contactoNombre || '';
  modelo.numeroIdentificativo = modelo.numeroIdentificativo || '';
  modelo.justificante = modelo.justificante || '';
  modelo.complementaria = !!modelo.complementaria;
  modelo.sustitutiva = !!modelo.sustitutiva;
  modelo.numeroPerceptores = Number(modelo.numeroPerceptores) || 0;
  modelo.totalBase = Number(modelo.totalBase) || 0;
  modelo.totalRetenciones = Number(modelo.totalRetenciones) || 0;
  modelo.avisos = Array.isArray(modelo.avisos) ? modelo.avisos : [];

  return modelo;
}

export function nuevoPerceptor180(): Model180Recipient {
  return {
    clave: null,
    uid: null,
    origen: ORIGEN_MANUAL,
    sobrescribeClave: null,
    nifPerceptor: '',
    nifRepresentante: '',
    nombre: '',
    provinciaPerceptor: '',
    modalidad: '1',
    reintegro: false,
    base: 0,
    porcentaje: 0,
    retencion: 0,
    ejercicioDevengo: 0,
    situacionInmueble: '',
    referenciaCatastral: '',
    tipoVia: '',
    nombreVia: '',
    tipoNumeracion: '',
    numeroCasa: '',
    calificador: '',
    bloque: '',
    portal: '',
    escalera: '',
    planta: '',
    puerta: '',
    complemento: '',
    localidad: '',
    municipio: '',
    codigoMunicipio: '',
    provinciaInmueble: '',
    codigoPostal: ''
  };
}

export function normalizarPerceptor180(origen: Partial<Model180Recipient>): Model180Recipient {
  const base: any = nuevoPerceptor180();
  const perceptor: any = { ...base, ...(origen || {}) };

  Object.keys(base).forEach(clave => {
    const defecto = base[clave];

    if (typeof defecto === 'string' && perceptor[clave] == null) perceptor[clave] = '';
    if (typeof defecto === 'number') perceptor[clave] = Number(perceptor[clave]) || 0;
    if (typeof defecto === 'boolean') perceptor[clave] = !!perceptor[clave];
  });

  return perceptor as Model180Recipient;
}
